module.exports = __webpack_public_path__ + "media/svg/symbols-760f08fc.svg";